import { type VirtualBackgroundFilter } from '@doxyme/types';
import {
  type VirtualBackground,
  backgrounds,
  defaultVirtualBackground,
} from './constants';
import { storage } from '@doxyme/ui/utils';
import { StorageKeys } from '../../../shared/constants';

export const getVirtualBackgroundIndexFromLocalStorage = (
  userId?: string,
): number => {
  if (!Boolean(userId)) {
    return 0;
  }

  const storedIndex = storage.getItem(
    `${StorageKeys.VirtualBackgroundEffect}:${userId}`,
    true,
  );

  if (Boolean(storedIndex)) {
    return Number(storedIndex);
  }

  // 0 - default index without any background
  return 0;
};

export const resolveVirtualBackgroundFromLocalStorage = (
  userId: string | undefined,
  availableBackgrounds: VirtualBackground[],
): VirtualBackground => {
  const storedIndex = getVirtualBackgroundIndexFromLocalStorage(userId);

  return (
    availableBackgrounds.find(
      (background) => background.index === storedIndex,
    ) ??
    availableBackgrounds.find((background) => background.index === 0) ??
    defaultVirtualBackground
  );
};

export const getVirtualBackgroundFromLocalStorage = (
  userId?: string,
  availableBackgrounds: VirtualBackground[] = backgrounds,
): VirtualBackground | undefined => {
  const storedIndex = getVirtualBackgroundIndexFromLocalStorage(userId);
  const background = availableBackgrounds.find(
    (item) => item.index === storedIndex,
  );

  return background ?? availableBackgrounds.find((item) => item.index === 0);
};

export const getVirtualBackgroundFilterFromLocalStorage = (
  userId?: string,
  availableBackgrounds: VirtualBackground[] = backgrounds,
): VirtualBackgroundFilter | undefined => {
  const bg = getVirtualBackgroundFromLocalStorage(userId, availableBackgrounds);

  return bg !== undefined && bg.index > 0 && bg.filter !== null
    ? bg.filter
    : undefined;
};

export const setVirtualBackgroundToLocalStorage = (
  background: VirtualBackground,
  userId: string,
): void => {
  storage.setItem(
    `${StorageKeys.VirtualBackgroundEffect}:${userId}`,
    background.index.toString(),
    true,
  );
};
